import { Typography } from '@mui/material';

export const Billing = () => {
  return (
    <Typography component="h2" variant="h3">
      Project billings
    </Typography>
  );
};
